import React, { useEffect, useState } from "react";

import Link from "next/link";
import { useRouter } from "next/router";

import { Button } from "studio-design-system";

import { ArrowRightIcon } from "~/components/cart/Icons/ArrowRightIcon";
import useVerifyAsCreatorOrAdmin from "~/hooks/creatorEditing/useVerifyAsCreatorOrAdmin";
import { useCreatorEditing } from "~/hooks/useCreatorEditing";

import * as styles from "./ProductPageEditBar.css";

export const ProductPageEditBar = () => {
  const [shouldShowStatusText, setShouldShowStatusText] = useState(false);
  const { isSavingChanges, savingStatusText, handleSetIsAISuggestionsShown, isAISuggestionsShown } =
    useCreatorEditing();
  const router = useRouter();
  const { draftProductId } = router.query;
  const { adminUrlParam } = useVerifyAsCreatorOrAdmin();
  const [shouldShowAISuggestions, setShouldShowAISuggestions] = useState(false);

  useEffect(() => {
    if (router.query && router.query.showAISuggestions) {
      setShouldShowAISuggestions(true);
    }
  }, [router.query]);

  useEffect(() => {
    if (isSavingChanges) {
      setShouldShowStatusText(true);
    } else {

      //   setTimeout(() => {
      //     //setShouldShowStatusText(false);
      //   }, 3000);
    }
  }, [isSavingChanges]);


  return (
    <div className={styles.editBarContainer}>
      <div className={styles.sectionContainer}>
        <Link href={"/classes/create/" + draftProductId + adminUrlParam}>
          <div className={styles.backButton}>
            <div className={styles.backArrowContainer}>
              <ArrowRightIcon />
            </div>
            Back
          </div>
        </Link>
        <div className={styles.barTitle}>Class Landing Page</div>
      </div>
      <div className={styles.sectionContainer}>
        {shouldShowAISuggestions && (
          <div className={styles.aiSuggestionsButton}>
            <Button
              variant="secondary"
              onClick={() => {


                if (isAISuggestionsShown) {
                  handleSetIsAISuggestionsShown(false);
                } else {
                  handleSetIsAISuggestionsShown(true);
                }
                // handleSetIsAISuggestionsShown(!!!isAISuggestionsShown);
              }}
            >
              {`${isAISuggestionsShown ? "Hide" : "Show"} AI Suggestions`}
            </Button>
          </div>
        )}

        {shouldShowStatusText && <div className={styles.savingStatus}>{savingStatusText}</div>}

        {/* <Button
          variant="secondary"
          onClick={() => {

          }}
        >
          Save Draft
        </Button> */}
      </div>
    </div>
  );
};
